import { Component } from '@angular/core';

@Component({
    selector: 'Error404',
    template: require('./404.template.html')
})
export class Error404Component {
    public dt = new Date();
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/errors/404.component.ts